var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "flatpickr", "flatpickr/dist/l10n/pt", "../utils/dateTimeHelper"], function (require, exports, flatpickr_1, pt_1, dateTimeHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    flatpickr_1 = __importDefault(flatpickr_1);
    dateTimeHelper_1 = __importDefault(dateTimeHelper_1);
    var DatePicker = (function () {
        function DatePicker(inputElement) {
            this._inputElement = inputElement;
        }
        DatePicker.prototype.Create = function () {
            var currentDate = new Date();
            this._flatpickr = flatpickr_1.default(this._inputElement, {
                dateFormat: "d/m/Y",
                monthSelectorType: "dropdown",
                locale: pt_1.Portuguese,
                maxDate: currentDate,
                allowInput: true
            });
        };
        DatePicker.prototype.SetDate = function (date) {
            this._flatpickr.setDate(dateTimeHelper_1.default.getDateOnlyAsString(date), true);
        };
        DatePicker.prototype.SetMinDate = function (date) {
            if (date === void 0) { date = new Date(); }
            this._flatpickr.set("minDate", dateTimeHelper_1.default.getDateOnlyAsString(date));
        };
        DatePicker.prototype.CreateWithConfig = function (position, enableTime) {
            if (enableTime === void 0) { enableTime = false; }
            this._flatpickr = flatpickr_1.default(this._inputElement, {
                dateFormat: "d/m/Y",
                monthSelectorType: "dropdown",
                locale: pt_1.Portuguese,
                allowInput: false,
                enableTime: enableTime,
                enableSeconds: enableTime,
                position: position,
            });
        };
        return DatePicker;
    }());
    exports.default = DatePicker;
});
